var lib_core = require("lib-core");
var cio_datamodel = require("cio-datamodel");
var cio_config = require("cio-config");
var FootprintGeneratorAddHelper = cio_datamodel.FootprintGeneratorAddHelper;
var PackageGeneratorInspectorConfig = require("./packageGeneratorInspectorConfig.js");

var AbstractIpcPadGeneratorInteractionModel = function(data, userSettingsModel, showFootprintParams) {
    lib_core.Model.call(this);

    this.componentDensityList = [];
    this.assemblyOutlineMappingTypeToBodyList = [];
    this.silkscreenMappingTypeToBodyList = [];
    this.padShapeList = [];
    this.data = data;
    this.userSettingsModel = userSettingsModel;
    this.showFootprintParams = this.value("showFootprintParams", true);
    this.showFootprintParams(showFootprintParams);
    
    //store lengthier localization fn as LCLZ and use it in all package IM to get locale string.
    this.getLocaleString = this.userSettingsModel.getLocaleString;
    this.LCLZ = this.getLocaleString.bind(userSettingsModel);

    this.initialize();
};

lib_core.inherit(AbstractIpcPadGeneratorInteractionModel, lib_core.Model);
AbstractIpcPadGeneratorInteractionModel.$class = 'AbstractIpcPadGeneratorInteractionModel';
module.exports = AbstractIpcPadGeneratorInteractionModel;

AbstractIpcPadGeneratorInteractionModel.prototype.getUnitFactor = function() {
    return cio_config.UnitConversions.convert(this.userSettingsModel.distanceUnit(), cio_config.UnitConversions.distanceDataUnit, 1);
};

AbstractIpcPadGeneratorInteractionModel.prototype.updateNameList = function() {
    this.data.nameList.removeAll();
    FootprintGeneratorAddHelper.updatePadNames(this.data, this.data.parent());
};

AbstractIpcPadGeneratorInteractionModel.prototype.initialize = function() {
    var self = this;

    /*
        component assembly outline mapping type list
     */
    for (var t in cio_datamodel.IpcDataModel.IPCRules.assemblyOutlineMappingTypeToBody) {
        var a = cio_datamodel.IpcDataModel.IPCRules.assemblyOutlineMappingTypeToBody[t];
        this.assemblyOutlineMappingTypeToBodyList.push([this.LCLZ(t, a), a]);
    }

    /*
        component silkscreen mapping type list
     */
    for (var t in cio_datamodel.IpcDataModel.IPCRules.silkscreenMappingTypeToBody) {
        var s = cio_datamodel.IpcDataModel.IPCRules.silkscreenMappingTypeToBody[t];
        this.silkscreenMappingTypeToBodyList.push([this.LCLZ(t, s), s]);
    }

    this.horizontalPadCount = this.shadow("horizontalPadCount",
        function() {
            return self.data.horizontalPadCount();
        },
        function(value) {
            value = parseInt(value);

            //pad count should not be zero
            if(value === 0) return false;
            
            //pad count should not be odd for following packages
            if(self.data.constructor === cio_datamodel.IpcDataModel.SoicSopData || 
                self.data.constructor === cio_datamodel.IpcDataModel.SojData ||
                self.data.constructor === cio_datamodel.IpcDataModel.DipData) {
                if(value % 2 !== 0) return false;
            }

            var status = self.data.horizontalPadCount(value);
            self.updateNameList();
            return status;
        },
        [self.data.horizontalPadCount]
    );

    this.verticalPinPitch = this.shadow("verticalPinPitch",
        function() {
            return self.data.verticalPinPitch() / self.getUnitFactor();
        },
        function(value) {
            value = parseFloat(value);
            return self.data.verticalPinPitch(value * self.getUnitFactor());
        }, 
        [
            self.data.verticalPinPitch, self.userSettingsModel.distanceUnit
        ]
    );
    
    this.bodyWidthMin = this.shadow("bodyWidthMin",
        function() {
            return self.data.bodyWidthMin() / self.getUnitFactor();
        },
        function(value) {
            value = parseFloat(value);

            if (self.data.constructor === cio_datamodel.IpcDataModel.ChipData ||
                self.data.constructor === cio_datamodel.IpcDataModel.ChipLedData ||
                self.data.constructor === cio_datamodel.IpcDataModel.MelfData || 
                self.data.constructor === cio_datamodel.IpcDataModel.MoldedBodyData ||
                self.data.constructor === cio_datamodel.IpcDataModel.QfnData ||
                self.data.constructor === cio_datamodel.IpcDataModel.ChipArrayTwoSideConvexData ||
                self.data.constructor === cio_datamodel.IpcDataModel.ChipArrayTwoSideFlatConcaveData ||
                self.data.constructor === cio_datamodel.IpcDataModel.ChipArrayFourSideFlatConcaveData) {
                self.horizontalLeadToLeadSpanMin(value);
            } else if (self.data.constructor === cio_datamodel.IpcDataModel.AluminumElectrolyticData) { //for ecap body is square
                self.bodyLengthMin(value);
            }

            return self.data.bodyWidthMin(value * self.getUnitFactor());
        },
        [
            self.data.bodyWidthMin, self.userSettingsModel.distanceUnit
        ]
    );

    this.bodyWidthMax = this.shadow("bodyWidthMax",
        function() {
            return self.data.bodyWidthMax() / self.getUnitFactor();
        },
        function(value) {
            value = parseFloat(value);

            if (self.data.constructor === cio_datamodel.IpcDataModel.ChipData ||
                self.data.constructor === cio_datamodel.IpcDataModel.ChipLedData ||
                self.data.constructor === cio_datamodel.IpcDataModel.MelfData || 
                self.data.constructor === cio_datamodel.IpcDataModel.MoldedBodyData ||
                self.data.constructor === cio_datamodel.IpcDataModel.QfnData ||
                self.data.constructor === cio_datamodel.IpcDataModel.ChipArrayTwoSideConvexData ||
                self.data.constructor === cio_datamodel.IpcDataModel.ChipArrayTwoSideFlatConcaveData ||
                self.data.constructor === cio_datamodel.IpcDataModel.ChipArrayFourSideFlatConcaveData) {
                self.horizontalLeadToLeadSpanMax(value);
            } else if (self.data.constructor === cio_datamodel.IpcDataModel.AluminumElectrolyticData) {
                self.bodyLengthMax(value);
            }

            return self.data.bodyWidthMax(value * self.getUnitFactor());
        }, 
        [
            self.data.bodyWidthMax, self.userSettingsModel.distanceUnit
        ]
    );

    this.bodyLengthMin = this.shadow("bodyLengthMin",
        function() {
            return self.data.bodyLengthMin() / self.getUnitFactor();
        },
        function(value) {
            value = parseFloat(value);

            if (self.data.constructor === cio_datamodel.IpcDataModel.ChipData || 
                self.data.constructor === cio_datamodel.IpcDataModel.ChipLedData ||
                self.data.constructor === cio_datamodel.IpcDataModel.MelfData) {//for chip/melf data terminal length is same as body length
                self.padHeightMin(value);
            } else if(self.data.constructor === cio_datamodel.IpcDataModel.QfnData) {//for qfn body size determines lead span
                self.verticalLeadToLeadSpanMin(value);
            }

            return self.data.bodyLengthMin(parseFloat(value) * self.getUnitFactor());
        }, 
        [
            self.data.bodyLengthMin, self.userSettingsModel.distanceUnit
        ]
    );

    this.bodyLengthMax = this.shadow("bodyLengthMax",
        function() {
            return self.data.bodyLengthMax() / self.getUnitFactor();
        },
        function(value) {
            value = parseFloat(value);

            if (self.data.constructor === cio_datamodel.IpcDataModel.ChipData ||
                self.data.constructor === cio_datamodel.IpcDataModel.ChipLedData ||
                self.data.constructor === cio_datamodel.IpcDataModel.MelfData) {
                self.padHeightMax(value);
            } else if(self.data.constructor === cio_datamodel.IpcDataModel.QfnData) {
                self.verticalLeadToLeadSpanMax(value);
            }

            return self.data.bodyLengthMax(parseFloat(value) * self.getUnitFactor());
        }, 
        [
            self.data.bodyLengthMax, self.userSettingsModel.distanceUnit
        ]
    );

    this.bodyHeightMin = this.shadow("bodyHeightMin",
        function() {
            return self.data.bodyHeightMin() / self.getUnitFactor();
        },
        function(value) {
            return self.data.bodyHeightMin(parseFloat(value) * self.getUnitFactor());
        }, 
        [
            self.data.bodyHeightMin, self.userSettingsModel.distanceUnit
        ]
    );

    this.bodyHeightMax = this.shadow("bodyHeightMax",
        function() {
            return self.data.bodyHeightMax() / self.getUnitFactor();
        },
        function(value) {
            return self.data.bodyHeightMax(parseFloat(value) * self.getUnitFactor());
        }, 
        [
            self.data.bodyHeightMax, self.userSettingsModel.distanceUnit
        ]
    );

    this.padShape = this.shadow("padShape",
        function() {
            return self.data.padShape();
        },
        function(value) {
            return self.data.padShape(value);
        },
        [
            self.data.padShape
        ]
    );

    //Note: In Eagle X% of pad roundness is equivalent to (X/2)% in circuit 
    this.roundedPadCornerSize = this.shadow("roundedPadCornerSize",
        function() {
            return 2 * self.data.roundedPadCornerSize();
        },
        function(value) {
            return self.data.roundedPadCornerSize(value / 2);
        },
        [
            self.data.roundedPadCornerSize
        ]
    );

    this.showRoundedPadCornerSizeField = this.shadow("showRoundedPadCornerSizeField",
        function() {
            return this.data.padShape() === cio_datamodel.IpcDataModel.ComponentAttribute.padShapes["RoundedRectangle"];
        },
        null,
        [
            self.data.padShape
        ]
    );

    this.assemblyOutlineMappingTypeToBody = this.shadow("assemblyOutlineMappingTypeToBody",
        function() {
            return self.data.assemblyOutlineMappingTypeToBody();
        },
        function(value) {
            return self.data.assemblyOutlineMappingTypeToBody(value);
        },
        [
            self.data.assemblyOutlineMappingTypeToBody
        ]
    );

    this.silkscreenMappingTypeToBody = this.shadow("silkscreenMappingTypeToBody",
        function() {
            return self.data.silkscreenMappingTypeToBody();
        },
        function(value) {
            return self.data.silkscreenMappingTypeToBody(value);
        },
        [   
            self.data.silkscreenMappingTypeToBody
        ]
    );

    this.densityLevel = this.shadow("densityLevel",
        function() {
            return self.data.densityLevel();
        },
        function(value) {
            value = parseInt(value);
            return self.data.densityLevel(value);
        }, 
        [
            self.data.densityLevel
        ]
    );
    
    //initialize inspector
    this.inspectorElements = {};
    this.inspectorElements.input_elements = [];
    
    //helper elements conatins title of inspector
    this.inspectorElements.help_elements = {
        name: this.getInspectorName()
    };
};

AbstractIpcPadGeneratorInteractionModel.prototype.getInspectorName = function() {
    throw new Error("Not implemented.");
};

//override this in child class to have different inspector elements
AbstractIpcPadGeneratorInteractionModel.prototype.getInspectorElements = function() {
    throw new Error("Not implemented.");
};

AbstractIpcPadGeneratorInteractionModel.prototype.getInspectorElementForPadCount = function() {
    return [PackageGeneratorInspectorConfig.getTextbox(this.LCLZ('#Pins', '# Pins'), this.horizontalPadCount)];
};

AbstractIpcPadGeneratorInteractionModel.prototype.getInspectorElementForPadShape = function() {
    return [PackageGeneratorInspectorConfig.getSelectbox(this.LCLZ('padShape', 'Pad Shape'), this.padShape, this.padShapeList, this.showFootprintParams)];
};

AbstractIpcPadGeneratorInteractionModel.prototype.getInspectorElementForPadRoundness = function() {
    return [PackageGeneratorInspectorConfig.getValueFixedUnit(this.LCLZ('padRoundness', 'Pad Roundness'), '', this.roundedPadCornerSize, '%', (this.showFootprintParams() ? this.showRoundedPadCornerSizeField : this.showFootprintParams))];
};

AbstractIpcPadGeneratorInteractionModel.prototype.getInspectorElementForDensityLevel = function() {
    return [PackageGeneratorInspectorConfig.getSelectbox(this.LCLZ('densityLevel', 'Density Level'), this.densityLevel, this.componentDensityList, this.showFootprintParams)];
};

AbstractIpcPadGeneratorInteractionModel.prototype.getInspectorElementForPitch = function() {
    return [PackageGeneratorInspectorConfig.getValueFixedUnit('e', this.LCLZ('pinPitch', 'Pin Pitch'), this.verticalPinPitch, this.userSettingsModel.distanceUnit)];
};

AbstractIpcPadGeneratorInteractionModel.prototype.getInspectorElementForLeadSpan = function() {
    throw new Error("Not implemented.");
};

AbstractIpcPadGeneratorInteractionModel.prototype.getInspectorElementForTerminalWidth = function() {
    throw new Error("Not implemented.");
};

AbstractIpcPadGeneratorInteractionModel.prototype.getInspectorElementForTerminalLength = function() {
    throw new Error("Not implemented.");
};

AbstractIpcPadGeneratorInteractionModel.prototype.getInspectorElementForBodyLength = function() {
    return [PackageGeneratorInspectorConfig.getMinMaxRow('D', this.LCLZ('bodyLength', 'Body Length'), false, this.bodyLengthMin, false, this.bodyLengthMax, this.userSettingsModel.distanceUnit)];
};

AbstractIpcPadGeneratorInteractionModel.prototype.getInspectorElementForBodyWidth = function() {
    throw new Error("Not implemented.");
};

AbstractIpcPadGeneratorInteractionModel.prototype.getInspectorElementForBodyHeight = function() {
    return [PackageGeneratorInspectorConfig.getMinMaxRow('A', this.LCLZ('bodyHeight', 'Body Height'), true, null, false, this.bodyHeightMax, this.userSettingsModel.distanceUnit)];
};

AbstractIpcPadGeneratorInteractionModel.prototype.getInspectorElementForBodyOffset = function() {
    throw new Error("Not implemented.");
};

AbstractIpcPadGeneratorInteractionModel.prototype.getInspectorElementForMapping = function() {
    var silkscreenMapping = PackageGeneratorInspectorConfig.getSelectbox(this.LCLZ('mapSilkscreen', 'Map Silkscreen to Body'), this.silkscreenMappingTypeToBody, this.silkscreenMappingTypeToBodyList, this.showFootprintParams);
    //var assemblyOutlineMapping = PackageGeneratorInspectorConfig.getSelectbox('Map Assembly Outline to Body', this.assemblyOutlineMappingTypeToBody, this.assemblyOutlineMappingTypeToBodyList, this.showFootprintParams);

    return [silkscreenMapping/*, assemblyOutlineMapping*/];
};